/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Uno_Release_Intro_BlurbInputs */



/**
* | output |
* | --- |
* | "oneAI {version} just landed! I can walk you through what's new and show you where everything lives. Where should we start?" |
*
* @param {Uno_Release_Intro_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_release_intro_blurb = /** @type {((inputs: Uno_Release_Intro_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Release_Intro_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`oneAI ${i?.version} ist da! Ich zeige Ihnen gerne, was es Neues gibt und wo Sie alles finden. Womit möchten Sie beginnen?`)
	return /** @type {LocalizedString} */ (`oneAI ${i?.version} just landed! I can walk you through what's new and show you where everything lives. Where should we start?`)
});